module.exports = __webpack_public_path__ + "da663c60ca00589eeb059cb4e2490f2c.svg";